import { Button, Card, CardActions, CardContent, CardHeader, Divider, Table, TableBody, TableCell, TableRow } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TeacherEdit } from './components';
import snakeToCamel from 'utils/snakeToTitle';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  actions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    '& > * + *': {
      marginLeft: 0
    }
  },
  buttonIcon: {
    marginRight: theme.spacing(1)
  },
  header: {
    fontWeight: 600
  }
}));

const TeacherInfo = props => {
  const { className, ...rest } = props;
  const model = useSelector(state => state.models.teacher);

  const classes = useStyles();

  const [openEdit, setOpenEdit] = useState(false);

  const handleEditOpen = () => {
    setOpenEdit(true);
  };

  const handleEditClose = () => {
    setOpenEdit(false);
  };

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Teacher Info" />
      <Divider />
      <CardContent className={classes.content}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className={classes.header}>Name</TableCell>
              <TableCell>{model.name_en}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Title</TableCell>
              <TableCell>{model.title}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Description</TableCell>
              <TableCell>{model.description}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Specialisation</TableCell>
              <TableCell>{snakeToCamel(model.specialisation)}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={classes.header}>Mastery Level</TableCell>
              <TableCell>{model.mastery_level && model.mastery_level.name_en}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button onClick={handleEditOpen}>
          <EditIcon className={classes.buttonIcon} />
          Edit
        </Button>
      </CardActions>
      <TeacherEdit onClose={handleEditClose} open={openEdit} />
    </Card>
  );
};

TeacherInfo.propTypes = {
  className: PropTypes.string,
};

export default TeacherInfo;
